<!-- 海口应收账欠款打印模板 -->
<template>
    <div v-loading="loading">
        <div id="printListContent">
            <div style="width:210mm;margin: 0 auto;color: #000;">
                <div id="top">
                    <div class="print-title-view">
                        <div v-if="isEditTitle" class="print-title">
                            <el-input type="text" v-model="titleConfig.RValue"></el-input>
                        </div>
                        <div v-else class="print-title">{{ titleConfig.RValue }}</div>
                    </div>
                </div>
                <div style="width:210mm;margin: 0 auto;" id="table">
                    <table cellspacing="0" cellpadding="1" width="100%" style="border-collapse: collapse;table-layout:fixed;" bordercolor="#333333" id="ftable">
                        <thead>
                            <tr style="text-align:center;font-weight: bold;">
                                <td width="22%">
                                    <div><b>收欠款单号</b></div>
                                </td>
                                <td width="11%">
                                    <div><b>结算日期</b></div>
                                </td>
                                <td>
                                    <div><b>客户名称</b></div>
                                </td>
                                <td width="10%">
                                    <div><b>支付方式</b></div>
                                </td>
                                <td width="10%">
                                    <div><b>本次收取</b></div>
                                </td>
                                <td width="12%">
                                    <div><b>预收款支付</b></div>
                                </td>
                                <td width="10%">
                                    <div><b>减收金额</b></div>
                                </td>
                                <td width="8%">
                                    <div><b>结算人</b></div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-bind:key="index" v-for="(AP, index) in dataList">
                                <td>{{ AP.OrderCode }}</td>
                                <td>{{ AP.PayTime }}</td>
                                <td>{{ AP.EntpCusName }}</td>
                                <td>{{ AP.PayTypeName }}</td>
                                <td style="text-align: right;">{{ (AP.ClosingBalance - AP.UnPaid - AP.OpeningBalance).toFixed(2) }}&nbsp;</td>
                                <td style="text-align: right;">{{ AP.OpeningBalance }}&nbsp;</td>
                                <td style="text-align: right;">{{ AP.UnPaid }}&nbsp;</td>
                                <td>{{ AP.Operator }}</td>
                            </tr>
                            <tr style="text-align:center;font-weight: bold;">
                                <td colspan="4">
                                    <div>
                                        <b>合计：{{ dataList.length }}项</b>
                                    </div>
                                </td>
                                <td align="right">{{ closingBalanceTotal.toFixed(2) }}&nbsp;</td>
                                <td align="right">{{ openingBalanceTotal.toFixed(2) }}&nbsp;</td>
                                <td align="right">{{ unPaidTotal.toFixed(2) }}&nbsp;</td>
                                <td width="8%"></td>
                            </tr>
                            <tr>
                                <td style="border: 0;padding:0;">&nbsp;</td>
                            </tr>
                            <tr>
                                <td colspan="8" style="border: 0;padding:0;">
                                    <table cellspacing="0" cellpadding="1" width="100%" bordercolor="#333333" id="ctable">
                                        <tbody>
                                            <template v-for="p in payWayCollects">
                                                <tr style="text-align:center;font-weight: bold;">
                                                    <td>{{ p[0] }}</td>
                                                    <td>{{ p[2] }}</td>
                                                    <td>{{ p[4] }}</td>
                                                    <td>{{ p[6] }}</td>
                                                    <td>{{ p[8] }}</td>
                                                    <td>{{ p[10] }}</td>
                                                    <td>{{ p[12] }}</td>
                                                    <td>{{ p[14] }}</td>
                                                </tr>
                                                <tr style="text-align:center;">
                                                    <td>{{ p[1] }}</td>
                                                    <td>{{ p[3] }}</td>
                                                    <td>{{ p[5] }}</td>
                                                    <td>{{ p[7] }}</td>
                                                    <td>{{ p[9] }}</td>
                                                    <td>{{ p[11] }}</td>
                                                    <td>{{ p[13] }}</td>
                                                    <td>{{ p[15] }}</td>
                                                </tr>
                                            </template>
                                            <tr>
                                                <td colspan="4" style="padding-left: 10px;padding-top: 10px;border: none;">打印人：{{ employeeName }}</td>
                                                <td colspan="4" style="text-align: right;padding-right: 10px;padding-top: 10px;border: none;">
                                                    打印日期：{{ printDate }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="btn-ctn-left">
                <div class="re-set">
                    <el-button class="btn-primary" @click="isEditTitle = true" v-if="titleConfig == null ? false : titleConfig.Result && !isEditTitle"
                        >编辑标题</el-button
                    >
                    <el-button class="btn-primary" @click="submitTitleConfig()" v-if="isEditTitle">保存标题</el-button>
                </div>
            </div>
            <div class="re-submit">
                <el-button class="btn-primary" @click="lodopPrint" v-if="!isDefaultSet">打印</el-button>
                <el-button class="btn-primary" v-print="'#printListContent'" v-else>打印</el-button>
                <el-button @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    components: {},
    props: {
        isInit: {
            default: false,
            type: Boolean
        },
        isDefaultSet: {
            default: false,
            type: Boolean
        },
        isPreview: {
            default: false,
            type: Boolean
        },
        sParams: {
            type: Object
        }
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            loading: false,
            closingBalanceTotal: 0,
            openingBalanceTotal: 0,
            unPaidTotal: 0,
            employeeName: userMsg.EmployeeName,
            printDate: '',
            searchParams: {},
            dataList: [],
            payWayList: [],
            payWayCollects: [],
            company: userMsg.EntpName,
            isEditTitle: false, //编辑标题
            titleConfig: {
                RValue: userMsg.EntpName + '应收账欠款汇总'
            } //标题配置
        };
    },
    watch: {},
    created() {},
    mounted() {
        let that = this;
        if (that.isInit) {
            this.getConfigByCodes().then(() => {
                that.init(false);
            });
        }
    },
    methods: {
        init(isPrint) {
            let that = this;
            that.loading = true;
            that.closingBalanceTotal = 0;
            that.openingBalanceTotal = 0;
            that.unPaidTotal = 0;
            that.dataList = [];
            that.payWayCollects = [];
            if (that.sParams) {
                that.sParams.page = 1;
                that.searchParams = { ...that.sParams };
            } else {
                that.searchParams = {};
            }
            let d = new Date();
            let year1, month1, day1;
            [year1, month1, day1] = [d.getFullYear(), d.getMonth() + 1, d.getDate()];
            that.printDate = `${year1}-${month1}-${day1}`;
            that.$util.getPay().then(data => {
                that.payWayList = data;
                that.getCusItemizedSummary(isPrint);
            });
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['dyyszqkbt'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'dyyszqkbt':
                                    this.titleConfig = data[i];
                                    if (!this.titleConfig || !this.titleConfig.RValue) this.titleConfig.RValue = this.company + '应收账欠款汇总';
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        getCusItemizedSummary(isPrint) {
            let that = this;
            that.loading = true;
            that.$util
                .axiosPost({
                    url: '/api/RevenueManagement_H/GetCusSettlementsList',
                    data: that.searchParams,
                    hideLoading: that.isInit
                })
                .then(res => {
                    let data = res.data;
                    if (!data.DataList || data.DataList.length == 0) {
                        if (that.searchData.page == 1) that.tableData = [];
                        return;
                    } else {
                        let list = [...that.dataList, ...data.DataList];
                        that.dataList = list;
                        if (that.dataList.length < res.count) {
                            that.searchParams.page++;
                            this.getCusItemizedSummary();
                        } else {
                            let noWay = false;
                            that.dataList.forEach(e => {
                                if (e.State == 1) {
                                    that.closingBalanceTotal += e.ClosingBalance - e.UnPaid - e.OpeningBalance;
                                    that.openingBalanceTotal += e.OpeningBalance;
                                    that.unPaidTotal += e.UnPaid;
                                }

                                if (!noWay && !e.PayTypeName) noWay = true;
                            });
                            let index = 0;
                            let arr = [];
                            if (noWay) that.payWayList.push({ Text: '未选支付方式' });
                            that.payWayList.forEach((e, i) => {
                                let payw = e.Text;
                                let sum = that.dataList
                                    .filter(f => f.State == 1)
                                    .reduce((sum, cur) => {
                                        if (cur.PayTypeName == payw || (payw == '未选支付方式' && !cur.PayTypeName)) {
                                            return sum + (cur.ClosingBalance - cur.UnPaid - cur.OpeningBalance);
                                        } else return sum;
                                    }, 0);
                                arr.push(payw);
                                arr.push(sum.toFixed(2));
                                if (index == 7 || i == that.payWayList.length - 1) {
                                    that.payWayCollects.push([...arr]);
                                    index = 0;
                                    arr = [];
                                } else {
                                    index++;
                                }
                            });
                            if (that.isInit) that.loading = false;
                            else {
                                this.$nextTick(() => {
                                    setTimeout(() => {
                                        that.lodopPrint();
                                    }, 100);
                                });
                            }
                        }
                    }
                })
                .catch(() => {
                    that.loading = false;
                });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                let topStyle = `
                    body{margin: 0 auto;width: 210m;}               
                    .print-title-view {
                        width: 100%;
                        padding-bottom:10px;
                    }

                    .print-title-view .print-title {
                        margin: 0 auto;
                        text-align: center;
                        font-size: 20px;
                        font-weight: bold;
                        color: #000;
                        min-height: 26px;
                        padding-top: 10px
                    }               
               `;
                let tableStyle = `
                    table,
                    td,
                    th {
                        border: solid 1px #000;
                        border-collapse: collapse;
                        color: #000;
                        padding-bottom: 3px;
                        padding-top: 3px;
                        padding-left: 2px;
                    }
                     /* 为了兼容火狐不换行 */
                    td{
                        word-break: break-all;word-wrap: break-word;
                    }                     
                    table{
                        border:none;
                        border-top: solid 1px #000;
                    }              
                `;

                LODOP.PRINT_INIT('打印应收账欠款汇总');
                LODOP.SET_PRINT_STYLEA(0, 'Horient', 2);
                let printContentHeight = document.getElementById('printListContent').clientHeight;
                let topHeight = document.querySelector('#printListContent #top').clientHeight;
                let tableHeight = document.querySelector('#printListContent #table').clientHeight;
                let printTableH = 1080 - topHeight;
                if (printContentHeight <= 1080) {
                    LODOP.SET_PRINT_PAGESIZE(3, '210mm', '20mm', ''); // 这里3表示纵向打印且纸高“按内容的高度”；580表示纸宽58mm；45表示页底空白4.5mm
                }

                LODOP.ADD_PRINT_HTM('0', '0', '100%', '100%', `<style>${topStyle}</style>` + document.querySelector('#printListContent #top').innerHTML);
                LODOP.ADD_PRINT_TABLE(
                    topHeight,
                    0,
                    '100%',
                    `BottomMargin:0px`,
                    `<style>${tableStyle}</style>` + document.querySelector('#printListContent #table').innerHTML
                );

                //放在底部会被页尾的内容遮挡
                LODOP.ADD_PRINT_HTM(10, 690, 300, 10, "<font><span tdata='pageNO' format='#'>第#页</span> / <span tdata='pageCount' format='#'>共#页</span></font>");
                LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);
                LODOP.SET_PRINT_STYLEA(0, 'Horient', 1);

                // LODOP.SET_PRINT_STYLEA(0,"PageIndex","3,Last-1");//只有在最后一页输出

                //选择操作系统中设为“默认”的打印机，“-1”代表默认打印机
                LODOP.SET_PRINTER_INDEX(-1);
                // LODOP.PRINT_DESIGN();

                if (!this.isInit) this.orderList = [];
                if (this.isPreview) LODOP.PREVIEW();
                //预览
                else LODOP.PRINT(); // 直接打印
            }
        },
        // 取消
        cancel() {
            this.$emit('closeDialog');
        },
        //提交打印标题
        submitTitleConfig() {
            this.isEditTitle = false;
            this.$util.setSysConfigValue(this.titleConfig.ConfigId, this.titleConfig.RValue);
        }
    }
};
</script>
<style lang="less" scoped media="print">
.print-title-view {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 20px 0;
}

.print-title-view .print-title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 50%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
    min-height: 26px;
}
.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
}
.btn-ctn-left {
    display: flex;
}
.re-submit {
    text-align: right;
}
table,
td,
th {
    border: solid 1px #000;
    border-collapse: collapse;
    color: #000;
    padding-bottom: 3px;
    padding-top: 3px;
    padding-left: 2px;
}
table {
    border: none;
    border-top: solid 1px #000;
}
</style>
